
import React from 'react';
import SimpleNavItem from './SimpleNavItem';
import CollapsibleNavItem from './CollapsibleNavItem';
import { NavItem } from './types';

type NavItemProps = {
  item: NavItem;
  expanded: boolean;
  isMobile: boolean;
  expandedItems: Record<string, boolean>;
  toggleExpandItem: (title: string, event: React.MouseEvent) => void;
  handleNavigation: () => void;
};

const SidebarNavItem = (props: NavItemProps) => {
  const { item } = props;

  if (item.children) {
    return <CollapsibleNavItem {...props} />;
  }

  return <SimpleNavItem 
    item={item} 
    expanded={props.expanded} 
    isMobile={props.isMobile} 
    handleNavigation={props.handleNavigation} 
  />;
};

export default SidebarNavItem;
